import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';

import { RootStoreState } from 'src/app/store';
import { EndorsementsSelectors } from '../../store';

@Component({
    selector: 'app-required-text-count',
    templateUrl: './required-text-count.component.html',
    styleUrls: ['./required-text-count.component.scss'],
    standalone: false
})
export class RequiredTextCountComponent implements OnInit {
  requiredTextTotal$: Observable<number>;
  constructor(private readonly store: Store<RootStoreState.State>) {}

  ngOnInit(): void {
    this.requiredTextTotal$ = this.store.pipe(
      select(EndorsementsSelectors.selectActiveDocumentRemainingTextBoxes)
    );
  }
}
